export const getCanonicalUrl = (
    publicUrl: string,
    pathname: string
): string => {
    const normalizedPublicUrl = publicUrl.replace(/\/+$/, '')
    const pathWithoutQuery = pathname.split(/[?#]/, 1)[0]
    const normalizedPathname =
        pathWithoutQuery === '/' ? '' : pathWithoutQuery.replace(/\/+$/, '')

    return `${normalizedPublicUrl}${normalizedPathname}`
}
